export const VAULT_MENU_ITEMS = [
  { id: 1, action: 'Cerrar Sesión' },
];

/** Limite de pestañas abiertas en Vault (sin contar la base `/layout/vault`). */
export const VAULT_MAX_OPEN_TABS = 8;